import * as mutations from './mutations';

export const authorization = {
  mutations: {
    ...mutations
  }
};
